import React from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportSearchKeywordsData } from "../../../../models/FacilityReportData";
import LocationKeywordsChart from "../../../FacilityDetailsComponents/LocationKeywordsChart";

interface ISearchKeywordsSectionProps {
  searchKeywords?: FacilityReportSearchKeywordsData;
  startDate?: string;
  endDate?: string;
}

export const SearchKeywordsSection: React.FunctionComponent<
  ISearchKeywordsSectionProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(
      `facilityReportsPage.facilityReportDetails.searchKeywordsSection.${key}`
    );
  const { searchKeywords, startDate, endDate } = props;

  if (!searchKeywords || !startDate || !endDate) {
    return null;
  }

  return (
    <div className="search-keywords-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-search-keywords-section"
      >
        <h2>{t("title")}</h2>
        {searchKeywords.ai_summary && (
          <p className="ai-summary">{searchKeywords.ai_summary}</p>
        )}
        <LocationKeywordsChart
          data={[searchKeywords.location_keyword_data]}
          canSelectionMultiLocations={false}
          initDateRange={{
            fromDate: startDate,
            toDate: endDate,
          }}
          showDownloadButtons={false}
        />
      </div>
    </div>
  );
};
